[
    {
        "type": "Column",
        "data": {
            "props": [
                {
                    "type": "Input",
                    "class": "lg:w-1/2 lg:px-4 lg:first:px-0 lg:last:pl-0 px-4 !my-3",
                    "data": {
                        "name": "guest_name",
                        "label": "نام و نام خانوادگی",
                        "props": {
                            "autofocus": true,
                            "autocomplete": "name"
                        }
                    }
                },
                {
                    "type": "Input",
                    "class": "lg:w-1/2 lg:px-4 lg:first:px-0 lg:last:pl-0 px-4 !my-3",
                    "data": {
                        "name": "guest_email",
                        "label": "ایمیل یا شماره موبایل",
                        "props": {
                            "autocomplete": "email"
                        }
                    }
                }
            ]
        }
    },
    {
        "type": "Input",
        "data": {
            "name": "title",
            "label": "عنوان"
        }
    },
    {
        "type": "Range",
        "data": {
            "name": "score",
            "label": "امتیاز شما",
            "formProps": {
                "hint": "5"
            },
            "props": {
                "size": "md",
                "min": 1,
                "max": 5,
                "step": 0.5
            }
        }
    },
    {
        "type": "TextArea",
        "data": {
            "name": "content",
            "label": "متن پیام",
            "props": {
                "rows": 12
            }
        }
    }
]